export default __webpack_public_path__ + "static/media/learning_icon_red.1e3ecb92.svg";